import {
  Avatar,
  ButtonGroup,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import { FiMoreHorizontal } from "react-icons/fi";
import { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import demoTicket from "./demoTicket.jpg";
import { useLocation, useNavigate } from "react-router-dom";
import { eventContractAddress } from "utils/config";
import { useWallet } from "store/wallet";
import { buyTickets } from "services/contract";
import { getBuyTicketDetails } from "services/contract";
import MDInput from "components/MDInput";
import createPostIMG from "assets/images/CreatePost.png";
import { getChangedPrice } from "services/contract";
import { useEffect } from "react";
import { getUpdatedPrice } from "services/contract";
import CircularProgress from "@mui/material/CircularProgress";
import Swal from "sweetalert2";
import { date } from "yup/lib/locale";
import soldOutLogo from "./soldout.png";
import MDBadge from "components/MDBadge";
import profileUser from "./profileUser.png";
import { getUserTokenBalance } from "services/contract";
// import singhCoinLogo from "assets/images/favicon.png";
import singhCoinLogo from "./SinghCoin.png";
import Moment from "react-moment";
import Footer from "examples/Footer";
import { postBuyerDetails } from "services/contract";
import { addMail } from "services/contract";
import { useSearchParams } from "react-router-dom";
import InputAdornment from "@mui/material/InputAdornment";
import { addEventOrganisers } from "services/contract";
import { getEventOrganisers } from "services/contract";
import { deactivateEvent } from "services/contract";
import { FaRegCalendarAlt } from "react-icons/fa";
import { MdOutlineModeEditOutline } from "react-icons/md";
import { MdDeleteOutline } from "react-icons/md";
import { MdOutlinePlace } from "react-icons/md";
import { MdOutlinePersonOutline } from "react-icons/md";
import { IoTicketOutline } from "react-icons/io5";
import { getEventsById } from "services/contract";
import DetailedLoader from "skeletonLoader/detailedLoader";
import axiosInstance from "axios/axiosInstance";

import { STAGING_API_URL } from "helpers/baseUrl";
import { LOCAL_FRONTEND_URL } from "helpers/baseUrl";
import baseUrl from "helpers/baseUrl";
import { redirectUrl } from "helpers/baseUrl";
import { toast } from "react-toastify";
import { Edit } from "@mui/icons-material";
import { updateEvent } from "services/contract";
import { getUserTokens } from "utils/services/local-storage/Auth";
import { formatTimeTo12Hour } from "layouts/dashboard";
import MDDatePicker from "components/MDDatePicker";
import MDTimePicker from "components/MDTimePicker";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";

function EventDetails() {
  let navigate = useNavigate();
  let location = useLocation();
  const { web3, isWeb3Enabled, address } = useWallet();
  const [dialogBox, setDialogBox] = useState(false);
  const [checkoutDialog, setCheckoutDialog] = useState(false);
  const [dialogBoxPrice, setDialogBoxPrice] = useState(false);
  const [balanceNumOfTickets, setBalanceNumOfTickets] = useState("");
  const [ticketCount, setTicketCount] = useState(0);
  const [changePrice, setChangePrice] = useState("");
  const [updatedPrice, setUpdatedPrice] = useState("");
  const [loader, setLoader] = useState(false);
  const [walletBalance, setWalletBalance] = useState("");
  const [buyerEmail, setBuyerEmail] = useState("");
  const [eventOrgAdd, setEventOrgAdd] = useState("");
  const [eventOrgAddLoading, setEventOrgAddLoading] = useState(false);
  const [gotEventOrgAdd, setGotEventOrgAdd] = useState([]);
  const [eventAddBoolean, setEventAddBoolean] = useState(false);
  const [searchParams] = useSearchParams();
  const [pageLoading, setPageLoading] = useState(true);
  const [creator, setCreator] = useState("");
  const [tokenId, setTokenId] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [eventName, setEventName] = useState("");
  const [eventType, setEventType] = useState("");
  const [category, setCategory] = useState("");
  const [photo, setPhoto] = useState("");
  const [venue, setVenue] = useState("");
  const [description, setDescription] = useState("");
  const [originalPrice, setOriginalPrice] = useState("");
  const [remainTicket, setRemainTicket] = useState("");
  const [soldTicket, setSoldTicket] = useState("");
  const [EventStatus, setEventStatus] = useState("");
  const [eventSellingStatus, setEventSellingStatus] = useState("");
  const [paymentLoader, setPaymentLoader] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);
  const [initialEvent, setInitialEvent] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const [eventDetails, setEventDetails] = useState(selectedEvent || {});
  const [previewImage, setPreviewImage] = useState(selectedEvent?.photo || "");

  const [date, setDate] = useState(new Date());
  const [time, setTime] = useState(null); // State for time

  const [errorMsg, setErrorMsg] = useState({
    name: { errorMsg: "" },
    venue: { errorMsg: "" },
    description: { errorMsg: "" },
    numberOfTickets: { errorMsg: "" },
    ticketPrice: { errorMsg: "" },
    date: { errorMsg: "" },
    time: { errorMsg: "" },
    category: { errorMsg: "" },
  });

  const [ticketType, setTicketType] = useState("Free");
  const [name, setName] = useState("");

  const [numberOfTickets, setNumberOfTickets] = useState();

  const [venueDetails, setVenueDetails] = useState("");
  const [ticketPrice, setTicketPrice] = useState(selectedEvent?.price);
  const [finalDate, setFinalDate] = useState(null);

  let currentDate = new Date(selectedEvent?.eventDateTime);
  currentDate = `${currentDate.getFullYear()}-${
    currentDate.getMonth() + 1 <= 9
      ? "0" + (currentDate.getMonth() + 1)
      : currentDate.getMonth() + 1
  }-${currentDate.getDate() <= 9 ? "0" + currentDate.getDate() : currentDate.getDate()}`;

  const currentHours = new Date(selectedEvent?.eventDateTime).getHours();
  const currentMinutes = new Date(selectedEvent?.eventDateTime).getMinutes();

  const formattedTime = formatTimeTo12Hour(currentHours, currentMinutes);

  const capitalizeFirstLetter = (value) => {
    return value && value[0].toUpperCase() + value.slice(1);
  };

  const handleChangeInput = (name, value) => {
    // console.log("namenvalue", name, value);
    if (name === "name") {
      setName(capitalizeFirstLetter(value));
    } else if (name === "description") {
      setDescription(value);
    } else if (name === "numberOfTickets") {
      setNumberOfTickets(value);
    } else if (name === "category") {
      setCategory(value);
    } else if (name === "date") {
      setDate(value);
    } else if (name === "venue") {
      setVenue(value);
    } else if (name === "venueDetails") {
      setVenueDetails(value);
    } else if (name === "ticketPrice") {
      setTicketPrice(value);
    } else {
      console.log("inputError");
    }
  };

  useEffect(() => {
    // if (Object.keys(web3).length != 0 && address != undefined) {
    //   fetchEventById();
    // }

    fetchEventById();
  }, [address, loader, eventOrgAdd]);

  const pathname = window.location.pathname;
  console.log("%%%%pathname", pathname);

  // Use URLSearchParams to extract the query parameters
  const queryParams = new URLSearchParams(location.search);

  // Extract the tokenId
  const id = queryParams.get("tokenId");
  console.log("$$$id", id);

  const fetchEventById = async () => {
    setPageLoading(true);
    console.log("searchParams", searchParams);
    const eventById = await getEventsById(id);
    console.log("BYID", eventById);
    setSelectedEvent(eventById?.[0]);

    setInitialEvent(eventById?.[0]);

    setCreator(eventById[0]?.user?.username);
    setTokenId(eventById[0]?._id);

    setEventDate(eventById[0]?.eventDateTime);
    setEventName(eventById[0]?.name);
    setEventType(eventById[0]?.eventType);
    setCategory(eventById[0]?.category);
    setPhoto(eventById[0]?.photo);
    setVenue(eventById[0]?.venue);
    setDescription(eventById[0]?.description);
    setOriginalPrice(eventById[0]?.price);
    setRemainTicket(eventById[0]?.ticketsAvailable);
    setSoldTicket(eventById[0]?.soldTicket);
    setEventStatus(eventById[0]?.EventStatus);
    setEventSellingStatus(eventById[0]?.sellingStatus);
    setPageLoading(false);
  };

  const handleEditClick = (eventData) => {
    setSelectedEvent(eventData);

    setInitialEvent(eventData);

    if (new Date(eventData?.eventDateTime) > new Date()) {
      setOpenDialog(true);
    } else {
      toast.error("Event is expired");
      console.log("event is expired");
    }
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    const res = await updateEvent({
      photo: selectedEvent?.photo,
      id: selectedEvent?._id,
      price: Number(ticketPrice),

      eventDateTime: finalDate,
      venue: venue,
      totalTickets: numberOfTickets,
      description: description,
    });

    fetchEventById();
    handleCloseDialog();
  };

  const handleCloseDialog = () => {
    setOpenDialog(false); // Close the dialog
    setSelectedEvent(null);
    setPreviewImage("");
    // Clear the selected event data
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setPreviewImage(imageUrl);
      setSelectedEvent((prev) => ({
        ...prev,
        photo: file, // Store the file directly
      }));
      setEventDetails((prev) => ({
        ...prev,
        photo: file,
      }));
    }
  };

  const handleBuyDialog = async () => {
    // if (!isWeb3Enabled) {
    //   // console.log("pls connect wallet");
    //   Swal.fire("", "Please connect your Metamask Wallet");
    //   return;
    // }

    // const chainId = await web3.eth.getChainId();

    // if (chainId !== 97) {
    //   // console.log("pls change network");

    //   Swal.fire("", "Please switch your metamask network to BNB Smartchain Testnet Network");
    //   return;
    // }

    setDialogBox(true);
  };

  const handleCloseDialogBox = () => {
    setDialogBox(false);
  };

  const handleBuy = async (e) => {
    e.preventDefault();
    if (!getUserTokens()) {
      console.log("here");
      navigate("/authentication/sign-in");
    } else {
      setLoader(true);

      const amount = originalPrice * ticketCount;

      try {
        // if (finalamount > 0) {
        console.log("basurl", baseUrl, redirectUrl);
        const response = await axiosInstance.post(
          `${baseUrl.baseUrl}/events/createBuyEventIntent`,
          {
            //https://events.singhcoin.io/event-details/?eventDetails=otherEvent&tokenId=${id}
            totalAmount: amount,
            eventId: id,
            ticketQuantity: ticketCount,
            return_url: `${redirectUrl}/event-details/?eventDetails=otherEvent&tokenId=${id}`,
            // `http://localhost:3000/event-details/?eventDetails=otherEvent&tokenId=${id}`,
            cancel_url: `${redirectUrl}/event-details/?eventDetails=otherEvent&tokenId=${id}`,
            // `http://localhost:3000/event-details/?eventDetails=otherEvent&tokenId=${id}`,
          }
        );
        console.log("response", response);
        if (response.data.data.url) {
          console.log("here", response.data.data.url);
          window.location.href = response.data.data.url;
          //redirect to response.data.url and whatever after success i m getting returnurl?token ad i need to call capture event api by passing token as payload
        } else {
          const response = await axiosInstance.post(`${baseUrl.baseUrl}/events/buyFreeTicket`, {
            ticketQuantity: ticketCount,
            eventId: id,
          });

          if (response.data) {
            setDialogBox(false);
            toast.success(`Ticket is successfully bought`, {
              position: "top-right",
              style: { padding: "4px" },
            });
            // Swal.fire("", "Ticket is successfully bought", "success");
          }
        }

        // setClientSecret(response.data.client_secret);
        // setCreatePaymentIntentId(response.data.id);
        // dialog.onTrue();
        setCheckoutDialog(true);
        // }
      } catch (error) {
        console.error("Payment failed:", error);
      }
      setLoader(false);
    }
  };

  const handleTicketCountAdd = () => {
    if (ticketCount < remainTicket) {
      setTicketCount((prev) => prev + 1);
    } else {
      console.log("valueErr");
    }
  };

  const handleTicketCountMinus = () => {
    if (ticketCount > 0) {
      console.log("count", ticketCount);
      setTicketCount((prev) => prev - 1);
    } else {
      console.log("valueErr");
    }
  };

  const handleChangePriceInput = (value) => {
    console.log("value", value);
    setChangePrice(value);
  };

  const handleChangePrice = async (e) => {
    e.preventDefault();
    setLoader(true);

    const changedPrice = await getChangedPrice(changePrice, eventSellingStatus, tokenId);

    // getChangedPrice(web3, address, tokenId, changePrice);
    console.log("changedPrice", changedPrice);
    setLoader(false);
    setDialogBoxPrice(false);
    // Swal.fire({
    //   icon: "success",
    //   text: "Price changed successfully",
    // });
    toast.success(`Price changed successfully`, {
      position: "top-right",
      style: { padding: "4px" },
    });
    setChangePrice("");
  };

  // const handleCancelChangePrice = () => {
  //   setDialogBoxPrice(false);
  // };

  // const handleCancelBuy = () => {
  //   setDialogBox(false);
  // };

  const handleViewSales = () => {
    /// creatoraddress for details
    navigate(`/order-details/?creatorAddress=${creator}&tokenId=${tokenId}`);
  };

  const handleAddOrganisers = async () => {
    if (gotEventOrgAdd.includes(eventOrgAdd)) {
      // Swal.fire("", "Given wallet address is already an organiser", "warning");
      toast.warning(`Given wallet address is already an organiser`, {
        position: "top-right",
        style: { padding: "4px" },
      });
      console.log("exist");
      return;
    }

    setEventOrgAddLoading(true);
    const addOrgRes = await addEventOrganisers(web3, tokenId, eventOrgAdd, address);
    console.log("addORG", addOrgRes);

    if (addOrgRes.blockHash) {
      // Swal.fire("", "Event organiser added", "success");
      toast.success(`Event organiser added`, {
        position: "top-right",
        style: { padding: "4px" },
      });
    } else {
      // Swal.fire("", "Incorrect wallet address", "warning");
      toast.warning(`Incorrect wallet address`, {
        position: "top-right",
        style: { padding: "4px" },
      });
    }
    setEventOrgAdd("");
    setEventOrgAddLoading(false);
  };

  // const handleDeactivate = async () => {
  //   const eventData = {
  //     walletAddress: address,
  //     tokenId: tokenId,
  //   };
  //   const eventDeactivate = await deactivateEvent(eventData);

  //   if (eventDeactivate.success === true) {
  //     Swal.fire("", "Event deactivated successfully", "success");
  //   }

  //   console.log("deactivateRes", eventDeactivate);
  // };
  console.log(
    "####searchParams.get()",
    searchParams.get("eventDetails"),
    "remaintickets",
    remainTicket,
    "original",
    originalPrice,
    new Date(eventDate),
    eventDate,
    new Date()
    // eventById[0]
  );

  const captureEvent = async (orderId) => {
    try {
      // if (finalamount > 0) {

      const response = await axiosInstance.post(`${baseUrl.baseUrl}/events/captureEventPayment`, {
        eventId: id,
        orderId: orderId,
      });
      console.log("captureEventPayment response", response);

      if (response.data) {
        setPaymentLoader(false);
        // Swal.fire("", "Ticket is successfully bought", "success");
        toast.success(`Ticket is successfully bought`, {
          position: "top-right",
          style: { padding: "4px" },
        });
        navigate(`/event-details/?eventDetails=otherEvent&tokenId=${id}`);
        fetchEventById();
      }
      // }
    } catch (error) {
      setPaymentLoader(false);
      console.error("Payment failed:", error);
      toast.error(`Payment failed`, {
        position: "top-right",
        style: { padding: "4px" },
      });
      // Swal.fire("", "Payment failed", "error");
    }
  };

  useEffect(() => {
    const token = queryParams.get("token");
    console.log("#token", token);
    if (token) {
      setPaymentLoader(true);
      captureEvent(token);
    }
  }, [location]);

  const handleDateChange = (newDate) => {
    setDate(newDate[0]);
    console.log("@here123", formattedTime, updateDateTimeWithStringTime(newDate[0], formattedTime));
    combineDateTime(
      newDate[0],
      finalDate ? finalDate : updateDateTimeWithStringTime(newDate[0], formattedTime)
    );
  };

  const handleTimeChange = (newTime) => {
    const currentDate = new Date();

    // current date and time
    console.log("formateed", formattedTime);
    const date1 = updateDateTimeWithStringTime(date, formattedTime);
    console.log("@1", date1);

    const selectedDateTime = new Date(
      date1.getFullYear(),
      date1.getMonth(),
      date1.getDate(),
      newTime.getHours(),
      newTime.getMinutes()
    );

    // Check if the selected time is in the past
    if (selectedDateTime < currentDate) {
      setErrorMsg((prevErrorMsg) => ({
        ...prevErrorMsg,
        time: { errorMsg: "You cannot select a time in the past" },
      }));
      return;
    }

    // Reset the error message if time is valid
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      time: { errorMsg: "" },
    }));

    setTime(newTime);

    // setDateString(date1);
    // setTimeString(newTime);
    // setA(date1)
    combineDateTime(date1, newTime);
  };

  const combineDateTime = (date, time) => {
    if (date && time) {
      const combinedDateTime = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        time.getHours(),
        time.getMinutes()
      );

      handleChangeInput("date", combinedDateTime);

      setFinalDate(combinedDateTime);
      console.log("@here", combinedDateTime);
    }
  };

  useEffect(() => {
    setEventType(selectedEvent?.venue === "Online" ? "Online" : "Offline");
    setDescription(selectedEvent?.description);
    setNumberOfTickets(selectedEvent?.totalTickets);
    setTicketPrice(selectedEvent?.price);

    setDate(currentDate);

    setTicketType(selectedEvent?.price === 0 ? "Free" : "Paid");
    setVenue(selectedEvent?.venue);
  }, [selectedEvent]);

  const updateDateTimeWithStringTime = (inputDate, timeString) => {
    let updatedDate;

    // Parse the time string (e.g., '11:20 PM')
    const [time, modifier] = timeString.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    // Convert 12-hour format to 24-hour format
    if (modifier === "PM" && hours < 12) {
      hours += 12; // Convert PM to 24-hour format
    }
    if (modifier === "AM" && hours === 12) {
      hours = 0; // Midnight case
    }

    // Check if inputDate is a Date object
    if (inputDate instanceof Date) {
      // If it's a Date object, create a new Date instance with the same date and updated time
      updatedDate = new Date(
        inputDate.getFullYear(),
        inputDate.getMonth(),
        inputDate.getDate(),
        hours,
        minutes
      );
    } else if (typeof inputDate === "string") {
      // If it's a string, assume it is in the format 'YYYY-MM-DD'
      // const dateParts = inputDate.split('-');
      // const year = parseInt(dateParts[0], 10);
      // const month = parseInt(dateParts[1], 10) - 1; // Months are 0-indexed in JavaScript
      // const day = parseInt(dateParts[2], 10);
      // updatedDate = new Date(year, month, day, hours, minutes);
      updatedDate = new Date(`${inputDate} ${timeString}`);
    } else {
      throw new Error("Invalid date format"); // Handle unexpected formats
    }

    console.log("@value", updatedDate);
    return updatedDate;
  };

  console.log(
    "@herefinal",
    // updateDateTimeWithStringTime(date, formattedTime),
    // finalDate

    // formattedTime,
    // "#ctest",

    // initialEvent?.photo === selectedEvent?.photo,
    // ticketPrice === selectedEvent?.price,
    // description === selectedEvent?.description,
    // venue === selectedEvent?.venue,

    // finalDate === null,

    // numberOfTickets === selectedEvent?.totalTickets
    finalDate,
    new Date(finalDate),
    new Date(selectedEvent?.eventDateTime),
    finalDate === null
      ? finalDate === null
      : new Date(finalDate).getTime() == new Date(selectedEvent?.eventDateTime).getTime()
    // finalDate,
    // new Date(selectedEvent?.eventDateTime)
  );

  return (
    <>
      <DashboardNavbar />

      {pageLoading ? (
        <>
          <DetailedLoader />
        </>
      ) : (
        <MDBox>
          <MDBox
            sx={{
              marginBottom: "3rem",
              height: { xs: "none", md: "500px" },
              width: "100%",
              backgroundImage: `url(${photo})`,
              objectFit: "contain",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <Grid
              container
              sx={{
                height: "100%",
                backgroundImage:
                  "linear-gradient(90deg,#1a1a1a,rgba(18, 18, 18, 0.9),rgba(18, 18, 18, 0.8),rgba(18, 18, 18, 0.9),rgba(18, 18, 18, 0.9), #1a1a1a)",
              }}
            >
              <Grid
                item
                container
                xs={12}
                md={4}
                sx={{
                  height: "100%",
                  // marginBottom: { xs: "1rem", md: "none" },
                  padding: "0 20px 0 0",
                  justifyContent: "right",
                  alignItems: "center",
                }}
              >
                <MDBox sx={{ height: "400px", width: "350px" }}>
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "10px 10px 10px 10px",
                    }}
                    src={photo}
                    alt="logo"
                  />
                </MDBox>
              </Grid>

              <Grid
                item
                container
                xs={12}
                md={5}
                sx={{
                  paddingLeft: "1rem",
                  // paddingRight: { xs: "1rem", md: "none" },
                  // paddingLeft: { xs: "1rem", md: "none" },
                  alignItems: "center",
                }}
              >
                <MDBox sx={{}}>
                  <MDBox sx={{ width: "100%", wordBreak: "break-word" }}>
                    <MDBox>
                      {/* <MDTypography fontWeight="bold" sx={{ fontSize: { xs: "30px", md: "20px" } }}>
                        {category} &nbsp; || &nbsp; {remainTicket} tickets remaining
                      </MDTypography> */}
                    </MDBox>
                    <MDBox>
                      <MDTypography
                        fontWeight="bold"
                        sx={{
                          fontSize: { xs: "30px", md: "40px" },
                          // overflow: "hidden",
                          // textOverflow: "ellipsis",
                          // whiteSpace: "nowrap",

                          // width: "600px",
                          // width: { xs: "100%", md: "600px" },
                          whiteSpace: "normal",
                          width: "100%",
                        }}
                      >
                        {eventName}
                      </MDTypography>
                    </MDBox>
                    <MDBox>
                      <MDTypography
                        fontWeight="regular"
                        sx={{ fontSize: { xs: "20px", md: "30px" } }}
                      >
                        <FaRegCalendarAlt size={20} />
                        &nbsp;
                        <Moment format="ddd, DD MMMM, YYYY hh:mm A [GMT]Z">
                          {new Date(eventDate)}
                        </Moment>
                      </MDTypography>
                    </MDBox>
                    <MDBox>
                      <MDTypography
                        fontWeight="regular"
                        sx={{ fontSize: { xs: "20px", md: "30px" } }}
                      >
                        <MdOutlinePlace size={20} />
                        &nbsp;
                        {venue}
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                  <MDBox
                    sx={{
                      marginBottom: "2rem",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <MDBox sx={{ marginLeft: "-5px", height: 30, width: 30 }}>
                      <img src={singhCoinLogo} style={{ width: "100%", height: "100%" }} />
                    </MDBox>

                    <MDTypography fontSize="30px">
                      {originalPrice === "0" ? "Free" : `$${Number(originalPrice).toFixed(2)}`}
                    </MDTypography>
                  </MDBox>
                  <MDBox sx={{ width: "100%", display: "flex", gap: "1rem" }}>
                    {/* <MDButton>
                  <MdDeleteOutline />
                </MDButton> */}

                    {searchParams.get("eventDetails") === "My Events" ? (
                      <MDButton
                        size="meduim"
                        disabled={new Date(eventDate) < new Date() || remainTicket === 0}
                        onClick={() => setOpenDialog(true)}
                      >
                        {new Date(eventDate) > new Date() ? (
                          remainTicket === 0 ? (
                            "Sold Out"
                          ) : (
                            <>
                              <MdOutlineModeEditOutline />
                              &nbsp; Edit
                            </>
                          )
                        ) : (
                          // )
                          "Ended"
                        )}
                      </MDButton>
                    ) : (
                      <MDButton
                        size="meduim"
                        disabled={new Date(eventDate) < new Date() || remainTicket === "0"}
                        onClick={() => handleBuyDialog()}
                      >
                        {/* {console.log("frm data", new Date(eventDate))}
                        {console.log("compare to today", new Date())} */}
                        {new Date(eventDate) > new Date() ? (
                          remainTicket === 0 ? (
                            "Sold Out"
                          ) : (
                            <>
                              <IoTicketOutline />
                              &nbsp; Buy Ticket
                            </>
                          )
                        ) : (
                          "Ended"
                        )}
                      </MDButton>
                    )}

                    {/* {searchParams.get("eventDetails") === "My Events" ? (
                      <MDButton size="meduim" onClick={() => handleViewSales()}>
                        <MdOutlinePersonOutline />
                        &nbsp; ATTENDEES
                      </MDButton>
                    ) : null} */}
                  </MDBox>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>

          <Grid
            container
            sx={{
              marginBottom: "2rem",
              // border: "1px solid red",
              // paddingLeft: "9rem",
              // paddingRight: "9rem",
              // marginBottom: "2rem",
              paddingLeft: { xs: "1rem", md: "8rem" },
              paddingRight: { xs: "1rem", md: "8rem" },
            }}
          >
            <Grid item container xs={12} sx={{ flexDirection: "column" }}>
              <Grid item>
                <MDBox sx={{}}>
                  <MDTypography variant="h3">About the event</MDTypography>
                </MDBox>
              </Grid>
              <Grid item>
                <MDBox>
                  <MDTypography fontWeight="regular" variant="h5">
                    {description}
                  </MDTypography>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>

          <Divider />

          <Grid
            sx={{
              marginBottom: "5rem",
              // border: "1px solid red",
              // paddingLeft: "9rem",
              // paddingRight: "9rem",
              // marginBottom: "2rem",
              paddingLeft: { xs: "1rem", md: "8rem" },
              paddingRight: { xs: "1rem", md: "8rem" },
            }}
          >
            <MDBox
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "0.5rem",
              }}
            >
              <MDTypography variant="h3">Other details</MDTypography>
              {/* {searchParams.get("eventDetails") === "My Events" ? (
                <MDBox sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                  <MDButton size="medium" onClick={() => setEventAddBoolean(true)}>
                    Add organisers
                  </MDButton>
                </MDBox>
              ) : null} */}
            </MDBox>

            {/* {searchParams.get("eventDetails") === "My Events" ? (
              <MDBox
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "0.5rem",
                }}
              >
                <MDBox sx={{ width: "35%" }}>
                  {eventAddBoolean && (
                    <MDInput
                      fullWidth
                      onChange={(e) => setEventOrgAdd(e.target.value)}
                      placeholder="Add organiser wallet address"
                      value={eventOrgAdd}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            <IconButton onClick={() => handleAddOrganisers()}>
                              <MDTypography color="button">
                                {eventOrgAddLoading ? (
                                  <CircularProgress color="inherit" size={25} />
                                ) : (
                                  <AddIcon />
                                )}
                              </MDTypography>
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                </MDBox>
              </MDBox>
            ) : null} */}

            <MDBox sx={{ display: "flex", marginBottom: "0.5rem" }}>
              <MDTypography fontWeight="regular" variant="h5">
                Venue :&nbsp;
              </MDTypography>
              <MDTypography fontWeight="light" variant="h5">
                {venue}
              </MDTypography>
            </MDBox>
            <MDBox
              sx={{
                display: "flex",
                flexWrap: "wrap",
                wordBreak: "break-word",
                marginBottom: "0.5rem",
              }}
            >
              <MDTypography fontWeight="regular" variant="h5">
                Creator :&nbsp;
              </MDTypography>
              <MDTypography fontWeight="light" variant="h5">
                {creator}
              </MDTypography>
            </MDBox>
            <MDBox sx={{ display: "flex", marginBottom: "0.5rem" }}>
              <MDTypography fontWeight="regular" variant="h5">
                Contract Address :&nbsp;
              </MDTypography>
              <MDTypography
                fontWeight="light"
                variant="h5"
                sx={{
                  wordBreak: "break-all", // Ensures the address breaks in the middle if it's too long
                  overflowWrap: "break-word", // Additional safeguard for breaking long words
                }}
              >
                {eventContractAddress}
              </MDTypography>
            </MDBox>
            <MDBox sx={{ display: "flex", marginBottom: "0.5rem" }}>
              <MDTypography fontWeight="regular" variant="h5">
                Token Standard :&nbsp;
              </MDTypography>
              <MDTypography fontWeight="light" variant="h5">
                ERC115
              </MDTypography>
            </MDBox>
            <MDBox sx={{ display: "flex", marginBottom: "0.5rem" }}>
              <MDTypography fontWeight="regular" variant="h5">
                Token Id :&nbsp;
              </MDTypography>
              <MDTypography fontWeight="light" variant="h5">
                {tokenId}
              </MDTypography>
            </MDBox>
            <MDBox sx={{ display: "flex", marginBottom: "0.5rem" }}>
              <MDTypography fontWeight="regular" variant="h5">
                Blockchain :&nbsp;
              </MDTypography>
              <MDTypography fontWeight="light" variant="h5">
                Binance
              </MDTypography>
            </MDBox>
            {searchParams.get("eventDetails") === "My Events" ? (
              <MDBox sx={{ display: "flex", marginBottom: "0.5rem" }}>
                <MDTypography fontWeight="regular" variant="h5">
                  Organisers-List :&nbsp;
                </MDTypography>
                {gotEventOrgAdd.length > 0 ? (
                  gotEventOrgAdd.map((item, idx) => (
                    <MDTypography key={idx} fontWeight="light" variant="h5">
                      {item}
                    </MDTypography>
                  ))
                ) : (
                  <MDTypography fontWeight="light" variant="h5">
                    No Organisers added yet
                  </MDTypography>
                )}
              </MDBox>
            ) : null}
          </Grid>
        </MDBox>
      )}

      {/* <Dialog
        fullWidth
        maxWidth="xs"
        open={dialogBoxPrice}
        onClose={() => handleCloseDialogBoxPrice()}
        // onClose={(_, reason) => {
        //   if (reason !== "backdropClick") {
        //     handleCloseDialogBoxPrice();
        //   }
        // }}
        sx={{
          // "& .MuiDialog-paper::-webkit-scrollbar": {
          //   display: "none",
          // },
          "& .MuiDialog-paper": {
            borderRadius: "25px",
            backgroundColor: "#00303A",
          },
          marginLeft: "3%",
        }}
      >
        <form onSubmit={(e) => handleChangePrice(e)}>
          <MDBox sx={{ backgroundSize: "cover" }}>
            <DialogTitle>
              <MDTypography fontWeight="regular">Change Price</MDTypography>
            </DialogTitle>
            <DialogContent>
              <MDInput
                // style={{ color: "black" }}
                fullWidth
                placeholder="Enter Price"
                type="number"
                required
                name="changePrice"
                value={changePrice}
                onChange={(e) => handleChangePriceInput(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <MDButton type="submit" disabled={loader}>
                <MDTypography>
                  {loader ? <CircularProgress color="inherit" size={25} /> : "Confirm"}
                </MDTypography>
              </MDButton>
            </DialogActions>
          </MDBox>
        </form>
      </Dialog> */}

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          style: {
            backgroundColor: "#1a1a1a", // Set dialog background color to black
            color: "white",
            // border: "1px solid white",
            // Set text color to white for contrast
          },
        }}
      >
        <DialogTitle>Edit Event</DialogTitle>
        <DialogContent>
          <form onSubmit={(e) => handleEdit(e)}>
            {/* Show initial event image if no new image is uploaded */}
            {!previewImage && selectedEvent?.photo && (
              <div style={{ position: "relative", marginBottom: "16px" }}>
                <img
                  style={{
                    width: "200px",
                    height: "200px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    display: "block",
                    margin: "0 auto",
                  }}
                  src={selectedEvent.photo}
                  alt="Event Logo"
                />
                {/* Circular "Edit Image" overlay button */}
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    color: "white",
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                    padding: "10px",
                    borderRadius: "50%", // Make the button circular
                    cursor: "pointer",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => document.querySelector('input[type="file"]').click()} // Trigger file input click
                >
                  <Edit style={{ fontSize: "24px" }} /> {/* Make the icon bigger */}
                </div>
              </div>
            )}

            {/* Preview the uploaded image */}
            {previewImage && (
              <div style={{ position: "relative", marginBottom: "16px" }}>
                <img
                  src={previewImage}
                  alt="Event Preview"
                  style={{
                    width: "200px",
                    height: "200px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
                {/* Circular "Change Image" overlay button */}
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    color: "white",
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                    padding: "10px",
                    borderRadius: "50%", // Circular button
                    cursor: "pointer",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => document.querySelector('input[type="file"]').click()} // Trigger file input click
                >
                  <Edit style={{ fontSize: "24px" }} />
                </div>
              </div>
            )}

            {/* <InputLabel sx={{ marginBottom: 2, color: "white" }}>Event Image</InputLabel> */}
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              style={{ display: "none" }}
            />

            {/* <TextField
                  label="Price"
                  type="number"
                  fullWidth
                  margin="normal"
                  value={selectedEvent?.price}
                  onChange={(e) => setSelectedEvent({ ...selectedEvent, price: e.target.value })}
                  InputLabelProps={{ style: { color: "white" } }} // White label text for the input
                  InputProps={{
                    style: { color: "white" }, // White text for input
                  }}
                /> */}

            <MDBox sx={{ marginBottom: "0.5rem" }}>
              <MDBox sx={{ display: "flex", gap: "10px" }}>
                <MDButton
                  name="offlineEvent"
                  variant={eventType === "Offline" ? "contained" : "outlined"}
                  size="small"
                  onClick={(e) => handleEventType(e.target.name)}
                >
                  Offline
                </MDButton>
                <MDButton
                  name="onlineEvent"
                  variant={eventType === "Online" ? "contained" : "outlined"}
                  size="small"
                  onClick={(e) => handleEventType(e.target.name)}
                >
                  Online
                </MDButton>
              </MDBox>
            </MDBox>
            {eventType === "Offline" ? (
              <>
                <MDBox sx={{ marginBottom: "0.5rem" }}>
                  <GooglePlacesAutocomplete
                    error={errorMsg.venue.errorMsg.length > 0 || null}
                    apiKey="AIzaSyDnRwrG8QHtzehsIYx-D3GuqjYRCT-qH7U"
                    selectProps={{
                      placeholder: "Select venue",
                      styles: {
                        placeholder: (provided) => ({
                          ...provided,
                          fontSize: "medium",
                        }),
                        control: (provided, state) => ({
                          ...provided,
                          backgroundColor: "transparent",
                          borderWidth: "0.1px",
                          borderStyle: "ridge",
                          // borderTopStyle: "groove",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          backgroundColor: "#121212",
                        }),
                        input: (provided, state) => ({
                          ...provided,
                          color: "white",
                        }),
                        option: (provided) => ({
                          ...provided,
                          color: "white",
                          cursor: "pointer",
                          "&:hover, &:focus, &:target, &:focus-within": {
                            backgroundColor: "#FF9607",
                          },
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          color: "white",
                        }),
                      },
                      // isClearable: true,
                      value: venue,
                      // onChange: setVenue,
                      onChange: (e) => {
                        handleChangeInput("venue", e);
                      },
                    }}
                  ></GooglePlacesAutocomplete>
                  <MDTypography fontWeight="light" fontSize="0.7rem" sx={{ color: "red" }}>
                    {errorMsg.venue.errorMsg}
                  </MDTypography>
                </MDBox>
                <MDBox sx={{ marginBottom: "0.5rem" }}>
                  <MDInput
                    fullWidth
                    placeholder="Venue details, Landmark, etc (optional)"
                    name="venueDetails"
                    value={venueDetails}
                    // error={errorMsg.numberOfTickets.errorMsg.length > 0}
                    onChange={(e) => handleChangeInput(e.target.name, e.target.value)}
                  />
                </MDBox>
              </>
            ) : null}

            <MDBox sx={{ marginBottom: "0.5rem" }}>
              <MDInput
                fullWidth
                placeholder="Enter number of tickets"
                type="number"
                inputProps={{ min: "1" }}
                name="numberOfTickets"
                value={numberOfTickets}
                error={errorMsg.numberOfTickets.errorMsg.length > 0}
                onChange={(e) => handleChangeInput(e.target.name, e.target.value)}
              />
              <MDTypography fontWeight="light" fontSize="0.7rem" sx={{ color: "red" }}>
                {errorMsg.numberOfTickets.errorMsg}
              </MDTypography>
            </MDBox>

            <MDBox sx={{ marginBottom: "0.5rem" }}>
              <MDDatePicker
                options={{ minDate: currentDate }}
                value={date}
                onChange={handleDateChange}
              />
            </MDBox>

            <MDBox sx={{ marginBottom: "0.5rem" }}>
              <MDTimePicker
                input={{ placeholder: "Select time" }}
                onChange={handleTimeChange}
                error={errorMsg.category.errorMsg.length > 0}
                defaultTime={formattedTime}
                setDefaultTime={setTime}
              />
              <MDTypography fontWeight="light" fontSize="0.7rem" sx={{ color: "red" }}>
                {errorMsg.time.errorMsg}
              </MDTypography>
            </MDBox>

            <MDBox sx={{ marginBottom: "0.5rem" }}>
              <MDBox sx={{ display: "flex", gap: "10px" }}>
                <MDButton
                  variant={ticketType === "Free" ? "contained" : "outlined"}
                  size="small"
                  onClick={() => handleFree()}
                >
                  Free
                </MDButton>
                <MDButton
                  variant={ticketType === "Paid" ? "contained" : "outlined"}
                  size="small"
                  onClick={() => setTicketType("Paid")}
                >
                  Paid
                </MDButton>
              </MDBox>
              {ticketType === "Paid" && (
                <>
                  <MDInput
                    sx={{ marginTop: "10px" }}
                    fullWidth
                    type="number"
                    inputProps={{ min: "0", step: "any" }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <img src={singhCoinLogo} width="18px" style={{}} />
                        </InputAdornment>
                      ),
                    }}
                    name="ticketPrice"
                    placeholder="Enter ticket price"
                    value={ticketPrice}
                    error={errorMsg.ticketPrice.errorMsg.length > 0}
                    onChange={(e) => handleChangeInput(e.target.name, e.target.value)}
                  />
                  <MDTypography fontWeight="light" fontSize="0.7rem" sx={{ color: "red" }}>
                    {errorMsg.ticketPrice.errorMsg}
                  </MDTypography>
                </>
              )}
            </MDBox>

            <MDBox sx={{ width: "100%", marginBottom: "3rem" }}>
              <MDInput
                fullWidth
                multiline={true}
                rows={6}
                name="description"
                placeholder="Enter description..."
                value={description}
                error={errorMsg.description.errorMsg.length > 0}
                onChange={(e) => handleChangeInput(e.target.name, e.target.value)}
              />
              <MDTypography fontWeight="light" fontSize="0.7rem" sx={{ color: "red" }}>
                {errorMsg.description.errorMsg}
              </MDTypography>
            </MDBox>

            <MDBox sx={{ width: "50%" }}>
              {/* disable if all the form data not filled */}
              <MDButton
                variant="contained"
                disabled={
                  initialEvent?.photo === selectedEvent?.photo &&
                  ticketPrice === selectedEvent?.price &&
                  description === selectedEvent?.description &&
                  venue === selectedEvent?.venue &&
                  (finalDate === null
                    ? finalDate === null
                    : new Date(finalDate).getTime() ==
                      new Date(selectedEvent?.eventDateTime).getTime()) &&
                  numberOfTickets === selectedEvent?.totalTickets
                }
                fullWidth
                type="submit"
                // onClick={() => handleEdit(e)}
              >
                <MDTypography>
                  {loader ? <CircularProgress color="inherit" size={25} /> : "Edit"}
                </MDTypography>
              </MDButton>
            </MDBox>
          </form>
        </DialogContent>
      </Dialog>
      <Dialog
        // sx={{ "& .MuiDialog-paper": { background: "rgb(242, 240, 254)" } }}
        fullWidth
        maxWidth="sm"
        open={dialogBox}
        onClose={() => handleCloseDialogBox()}
        // onClose={(_, reason) => {
        //   if (reason !== "backdropClick") {
        //     handleCloseDialogBox();
        //   }
        // }}
        sx={{
          // "& .MuiDialog-paper::-webkit-scrollbar": {
          //   display: "none",
          // },

          "& .MuiDialog-paper": {
            borderRadius: "24px",
            backgroundColor: "#383839 !important",
          },
          marginLeft: "3%",
        }}
      >
        <form onSubmit={(e) => handleBuy(e)}>
          <MDBox
            sx={{
              // backgroundImage: `url(${createPostIMG})`
              backgroundSize: "cover",
            }}
          >
            <DialogContent sx={{ display: "flex", justifyContent: "space-between" }}>
              <MDBox>
                <MDTypography color="white">Available Tickets:</MDTypography>
                <MDTypography color="white">Quantity:</MDTypography>
                <MDTypography color="white">Price:</MDTypography>
                {/* <MDTypography sx={{ marginBottom: "2rem" }} color="white">
                  Email Id:
                </MDTypography> */}

                <MDTypography color="white" fontWeight="bold">
                  Total Amount:
                </MDTypography>
              </MDBox>
              <MDBox sx={{ textAlign: "right" }}>
                <MDTypography color="white">{remainTicket}</MDTypography>
                <ButtonGroup size="small" sx={{ borderRadius: "15px", gap: "0.5rem" }}>
                  <IconButton
                    size="small"
                    sx={{ backgroundColor: "#FF9607", color: "#ffff" }}
                    onClick={() => handleTicketCountMinus()}
                  >
                    <RemoveIcon fontSize="small" />
                  </IconButton>

                  <MDTypography color="white" sx={{ alignSelf: "center" }} fontSize="small">
                    {ticketCount}
                  </MDTypography>

                  <IconButton
                    size="small"
                    sx={{ backgroundColor: "#FF9607", color: "#ffff" }}
                    onClick={() => handleTicketCountAdd()}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton>
                </ButtonGroup>
                <MDTypography color="white">{originalPrice}</MDTypography>
                {/* <MDInput
                  type="email"
                  placeholder="Enter email"
                  required
                  sx={{ marginBottom: "2rem" }}
                  onChange={(e) => setBuyerEmail(e.target.value)}
                /> */}
                <MDTypography color="white" fontWeight="bold">
                  {originalPrice * ticketCount}
                </MDTypography>
              </MDBox>
            </DialogContent>
            <DialogActions>
              <MDButton
                disabled={loader || ticketCount === 0}
                type="submit"
                //  onClick={() => handleBuy()}
              >
                <MDTypography>
                  {loader ? <CircularProgress color="inherit" size={25} /> : "Buy Now"}
                </MDTypography>
              </MDButton>
            </DialogActions>
          </MDBox>
        </form>
      </Dialog>

      {paymentLoader && (
        <MDBox
          sx={{
            position: "fixed",
            top: 0,

            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1300, // ensures it is above everything
          }}
        >
          <CircularProgress color="secondary" />
          <Typography variant="body1" sx={{ mt: 2 }}>
            Processing...
          </Typography>
        </MDBox>
      )}
      <Footer />
    </>
  );
}

export default EventDetails;
